import React, { Component } from 'react';
import styled from 'styled-components';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import api from 'api';
import WP from 'WP';

import css from 'css';

import Logo from 'images/Logo';

import Container from 'partials/Container';
import Menu from 'partials/Menu';

import {
    setTimeplan
} from 'store';

const Header = styled.header`
    height:130px;
    z-index: ${props => !props.menuVisible ? 999 : 1001};
    position:absolute;
    width:100%;
    top:0;
    left:0;
    display:flex;
    align-items:center;
    flex: 1 0 auto;
    background: ${props => props.backgroundType === 'solid' ? css.colors.main : 'transparent'};

    @media(max-width: 767px) {
        height:90px;
    }

    .container {
        display:flex;
        align-items:center;
        flex: 1 0 auto;
        justify-content: space-between;
        z-index:101;
    }
`

const LogoWrapper = styled.div`
    svg {
        ${props => props.pageBackground === 'main' || props.headerColor === 'white' ? `
            g {
                fill: #fff;
            }
        ` : ``}

        width: 282px;

        @media(max-width: 767px) {
            width: 174px;
            height: 64px;
        }
        @media(max-width: 320px) {
            width: 140px;
            height: 32px;
            margin-top:6px;
        }
    }

    ${props => props.pageBackground === 'main' || props.headerColor === 'white' ? `
        a:focus {
            outline: 1px dotted #fff
        }
    ` : `
        a:focus {
            outline: 1px dotted ${css.colors.main};
        }
    `}
`

class SiteHeader extends Component {
    constructor() {
        super();

        this.state = {
            menuVisible: null,
        }
    }

    componentDidMount() {
        api.getMenuByLocation('primary_menu');
        api.getMenuByLocation('secondary_menu');

        window.addEventListener('keydown', this._onKeyDown.bind(this));

        let isTimeplan = this.props.location.pathname.includes('timeplan');

        if (this.props.isTimeplan !== isTimeplan) {
            this.props.setTimeplan(isTimeplan);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            let isTimeplan = this.props.location.pathname.includes('timeplan');

            if (this.props.isTimeplan !== isTimeplan) {
                this.props.setTimeplan(isTimeplan);
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this._onKeyDown.bind(this));
    }

    _onKeyDown(e) {
        if (this.state.menuVisible) {
            let isEscape = false;
            e = e || window.event;

            if ('key' in e) {
                isEscape = e.key === 'Escape' || e.key === 'Esc';
            } else {
                isEscape = e.keyCode === 27;
            }

            if (isEscape) {
                this.setState({ menuVisible: false });
            }
        }
    }

    _toggleMenu() {
        this.setState({ menuVisible: !this.state.menuVisible });
    }

    _onMenuLinkClick(item, e) {
        if (item.children) {
            this.props.history.push(item.children[0].url.replace(WP.base_url, ''));

            e.preventDefault();

            return;
        }

        this.setState({ menuVisible: false });
    }

    _onLogoClick() {
        if (this.state.menuVisible) {
            this.setState({ menuVisible: false });
        }
    }

    render() {
        const { menuVisible } = this.state;
        const { primaryMenu, secondaryMenu, currentView, color } = this.props;
        const pageBackground = currentView && currentView.acf && currentView.acf.page_background ? currentView.acf.page_background : 'white';

        let headerColor = currentView && currentView.acf && currentView.acf.header_color ? currentView.acf.header_color : 'dark';
        
        if (color) {
            headerColor = color;
        }
       
        if (window.matchMedia("(max-width: 767px)").matches) {
            headerColor = 'dark';
        }

        return (
            <Header id="header" ref="header" menuVisible={menuVisible} >
                <Container flex justify="space-between" align="center">
                    <LogoWrapper pageBackground={pageBackground} headerColor={headerColor}>
                        <NavLink className="logo" to={WP.lang === 'en' ? '/en' : '/'} onClick={this._onLogoClick.bind(this)}>
                            <Logo />
                        </NavLink>
                    </LogoWrapper>
                    <Menu
                        pageBackground={pageBackground}
                        headerColor={headerColor}
                        menuVisible={menuVisible}
                        primaryMenu={primaryMenu}
                        secondaryMenu={secondaryMenu}
                        onMenuLinkClick={this._onMenuLinkClick.bind(this)}
                        handleClickOutside={e => menuVisible ? this.setState({ menuVisible: false }) : null}
                        onChamburgerClick={this._toggleMenu.bind(this)}
                    />
                </Container>
            </Header>
        );
    }
}

const mapStateToProps = state => ({
    primaryMenu: state.menus.primary_menu ? state.menus.primary_menu.items : [],
    secondaryMenu: state.menus.secondary_menu ? state.menus.secondary_menu.items : [],
    currentView: state.currentView,
    isTimeplan: state.cart.isTimeplan
});

const actions = {
    setTimeplan
}

export default withRouter(connect(mapStateToProps, actions)(SiteHeader));



// WEBPACK FOOTER //
// ./src/partials/Header.js